import React, { FC, InputHTMLAttributes, MouseEvent } from "react";
import InlineSvg from "Shared/components/inline-svg";
import { joinClassNames as c } from "Shared/util/styles";
import styles from "./input-checkbox.css";

export type InputCheckboxChanged<
    TValue extends InputHTMLAttributes<any>["value"] = InputHTMLAttributes<any>["value"],
> = {
    isChecked: boolean;
    value?: TValue;
};

export type InputCheckboxProps = {
    checked: boolean;
    className?: string;
    classNameLabel?: string;
    disabled?: boolean;
    label?: string;
    onChange?: (props: InputCheckboxChanged<any>) => void;
    value?: InputHTMLAttributes<any>["value"];
};

const InputCheckbox: FC<InputCheckboxProps> = ({
    checked,
    onChange,
    disabled,
    label,
    className,
    classNameLabel,
    value,
}) => {
    const handleChanged = (_?: MouseEvent<HTMLSpanElement>) =>
        onChange?.({
            isChecked: !checked,
            value,
        });

    return (
        <span
            className={styles.container}
            onClick={!disabled ? handleChanged : undefined}
        >
            <input
                checked={checked}
                className={styles.nativeCheckbox}
                disabled={disabled}
                readOnly
                type="checkbox"
                value={value}
            />
            <span
                className={c(
                    styles.checkbox,
                    disabled && styles.disabled,
                    className,
                )}
            >
                {checked && <InlineSvg src="/check-mark.svg" />}
            </span>
            {label && (
                <span
                    className={c(
                        styles.label,
                        disabled && styles.disabled,
                        classNameLabel,
                    )}
                >
                    {label}
                </span>
            )}
        </span>
    );
};

export default InputCheckbox;
